import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#081a13] text-gray-400 py-12 px-4 sm:px-6 lg:px-8 text-center text-sm" data-id="element-54">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-55">
          <div className="flex flex-wrap justify-center gap-6" data-id="element-56">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-gold transition-colors" data-id="element-57">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-gold transition-colors" data-id="element-58">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs text-gray-500 max-w-2xl mx-auto" data-id="element-59">
            Los resultados individuales pueden variar. Este producto no
            sustituye el consejo médico profesional, diagnóstico o tratamiento.
            Siempre busque el consejo de su médico u otro proveedor de salud
            calificado con cualquier pregunta que pueda tener sobre una
            condición médica.
          </p>

          <p data-id="element-60">© 2025 Zeklo. Todos los derechos reservados.</p>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80" onClick={() => setActiveModal(null)} data-id="element-61">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200" onClick={e => e.stopPropagation()} data-id="element-62">
            <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white z-10" data-id="element-63">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-64">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-800" data-id="element-65">
                <XIcon className="w-5 h-5" data-id="element-66" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)] text-left text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-67">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-68" /> : <TermsContent data-id="element-69" />}
            </div>
          </div>
        </div>}
    </>;
}
function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="text-base font-bold text-gray-900 mt-2" data-id="element-70">{children}</h3>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-71">
        Última actualización: 30 de marzo de 2026
      </p>

      <SectionTitle data-id="element-72">1. Responsable del tratamiento</SectionTitle>
      <p data-id="element-73">
        El responsable del tratamiento de tus datos personales es{' '}
        <strong data-id="element-74">Zeklo</strong> (en adelante, "nosotros"). Puedes contactarnos en
        cualquier momento a través de nuestro correo electrónico de soporte.
      </p>

      <SectionTitle data-id="element-75">2. Datos que recopilamos</SectionTitle>
      <p data-id="element-76">Recopilamos los siguientes datos personales:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-77">
        <li data-id="element-78">
          <strong data-id="element-79">Datos de identificación:</strong> nombre, dirección de correo
          electrónico.
        </li>
        <li data-id="element-80">
          <strong data-id="element-81">Datos de pago:</strong> procesados de forma segura a través de
          Hotmart. No almacenamos datos de tarjetas de crédito.
        </li>
        <li data-id="element-82">
          <strong data-id="element-83">Datos de navegación:</strong> dirección IP, tipo de navegador,
          páginas visitadas, tiempo de permanencia, mediante cookies y
          herramientas de análisis como Meta Pixel.
        </li>
      </ul>

      <SectionTitle data-id="element-84">3. Finalidad del tratamiento</SectionTitle>
      <p data-id="element-85">Utilizamos tus datos para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-86">
        <li data-id="element-87">
          Gestionar tu compra y darte acceso al producto digital adquirido.
        </li>
        <li data-id="element-88">Enviarte comunicaciones relacionadas con tu compra.</li>
        <li data-id="element-89">
          Enviarte comunicaciones comerciales si has dado tu consentimiento
          expreso.
        </li>
        <li data-id="element-90">Mejorar nuestros servicios y la experiencia de usuario.</li>
        <li data-id="element-91">Cumplir con obligaciones legales y fiscales.</li>
      </ul>

      <SectionTitle data-id="element-92">4. Base legal</SectionTitle>
      <p data-id="element-93">
        El tratamiento de tus datos se basa en: la ejecución del contrato de
        compra, tu consentimiento (para comunicaciones comerciales y cookies no
        esenciales), y nuestro interés legítimo en mejorar nuestros servicios.
      </p>

      <SectionTitle data-id="element-94">5. Cookies y Meta Pixel</SectionTitle>
      <p data-id="element-95">
        Utilizamos cookies propias y de terceros, incluyendo el Meta Pixel de
        Facebook (ID: 1377433624081067), para medir la efectividad de nuestras
        campañas publicitarias y mejorar tu experiencia. Estos datos se
        comparten con Meta Platforms, Inc. Puedes gestionar tus preferencias de
        cookies en la configuración de tu navegador.
      </p>

      <SectionTitle data-id="element-96">6. Destinatarios de los datos</SectionTitle>
      <p data-id="element-97">Tus datos pueden ser compartidos con:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-98">
        <li data-id="element-99">
          <strong data-id="element-100">Hotmart:</strong> como plataforma de procesamiento de pagos y
          entrega del producto digital.
        </li>
        <li data-id="element-101">
          <strong data-id="element-102">Meta Platforms:</strong> a través del Pixel de Facebook para
          fines publicitarios.
        </li>
        <li data-id="element-103">
          <strong data-id="element-104">Proveedores de servicios:</strong> hosting, email marketing,
          bajo acuerdos de confidencialidad.
        </li>
      </ul>

      <SectionTitle data-id="element-105">7. Conservación de datos</SectionTitle>
      <p data-id="element-106">
        Conservaremos tus datos mientras exista una relación contractual y,
        posteriormente, durante los plazos legalmente establecidos. Los datos
        para fines comerciales se conservarán hasta que retires tu
        consentimiento.
      </p>

      <SectionTitle data-id="element-107">8. Tus derechos</SectionTitle>
      <p data-id="element-108">Tienes derecho a:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-109">
        <li data-id="element-110">Acceder, rectificar o suprimir tus datos personales.</li>
        <li data-id="element-111">Limitar u oponerte al tratamiento.</li>
        <li data-id="element-112">Portabilidad de tus datos.</li>
        <li data-id="element-113">Retirar tu consentimiento en cualquier momento.</li>
        <li data-id="element-114">
          Presentar una reclamación ante la Agencia Española de Protección de
          Datos (AEPD).
        </li>
      </ul>
      <p data-id="element-115">
        Para ejercer estos derechos, contacta con nosotros a través de nuestro
        correo electrónico de soporte.
      </p>

      <SectionTitle data-id="element-116">9. Seguridad</SectionTitle>
      <p data-id="element-117">
        Implementamos medidas técnicas y organizativas adecuadas para proteger
        tus datos personales contra acceso no autorizado, pérdida o destrucción.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-118">
        Última actualización: 30 de marzo de 2026
      </p>

      <SectionTitle data-id="element-119">1. Identificación</SectionTitle>
      <p data-id="element-120">
        Este sitio web y el producto digital "El Reinicio Biológico" son
        propiedad de <strong data-id="element-121">Zeklo</strong>. Al acceder a este sitio web o
        adquirir nuestros productos, aceptas los presentes Términos y
        Condiciones.
      </p>

      <SectionTitle data-id="element-122">2. Objeto</SectionTitle>
      <p data-id="element-123">
        Estos términos regulan la compra y el acceso al producto digital "El
        Reinicio Biológico", un programa informativo de 14 días sobre bienestar
        y hábitos alimenticios, incluyendo todos los bonos asociados.
      </p>

      <SectionTitle data-id="element-124">3. Proceso de compra</SectionTitle>
      <ul className="list-disc pl-5 space-y-1" data-id="element-125">
        <li data-id="element-126">La compra se realiza a través de la plataforma Hotmart.</li>
        <li data-id="element-127">El precio del producto es de 26€ (IVA incluido).</li>
        <li data-id="element-128">
          Una vez completado el pago, recibirás acceso inmediato al contenido
          digital.
        </li>
        <li data-id="element-129">Hotmart actúa como intermediario en el procesamiento del pago.</li>
      </ul>

      <SectionTitle data-id="element-130">4. Acceso al producto</SectionTitle>
      <p data-id="element-131">
        Tras la compra, recibirás un correo electrónico con las instrucciones de
        acceso. El acceso es personal e intransferible. Está prohibido
        compartir, distribuir o revender el contenido.
      </p>

      <SectionTitle data-id="element-132">5. Garantía de devolución</SectionTitle>
      <p data-id="element-133">
        Ofrecemos una garantía de satisfacción de{' '}
        <strong data-id="element-134">15 días naturales</strong> desde la fecha de compra. Si no estás
        satisfecho/a con el producto, puedes solicitar un reembolso completo
        dentro de este plazo sin necesidad de justificación. La solicitud se
        gestiona a través de Hotmart.
      </p>

      <SectionTitle data-id="element-135">6. Propiedad intelectual</SectionTitle>
      <p data-id="element-136">
        Todo el contenido del producto (textos, imágenes, diseños, metodología)
        está protegido por derechos de propiedad intelectual. Queda prohibida su
        reproducción, distribución o transformación sin autorización expresa.
      </p>

      <SectionTitle data-id="element-137">7. Exención de responsabilidad sanitaria</SectionTitle>
      <p data-id="element-138">
        "El Reinicio Biológico" es un producto informativo y educativo.{' '}
        <strong data-id="element-139">
          No sustituye el consejo médico profesional, diagnóstico ni
          tratamiento.
        </strong>{' '}
        Los resultados individuales pueden variar. Siempre consulta con un
        profesional de la salud antes de realizar cambios significativos en tu
        alimentación o estilo de vida.
      </p>

      <SectionTitle data-id="element-140">8. Limitación de responsabilidad</SectionTitle>
      <p data-id="element-141">
        Zeklo no se hace responsable de los resultados individuales obtenidos
        con el uso del producto. Los testimonios mostrados representan
        experiencias individuales y no garantizan resultados específicos.
      </p>

      <SectionTitle data-id="element-142">9. Modificaciones</SectionTitle>
      <p data-id="element-143">
        Nos reservamos el derecho de modificar estos Términos y Condiciones en
        cualquier momento. Las modificaciones serán efectivas desde su
        publicación en este sitio web.
      </p>

      <SectionTitle data-id="element-144">10. Legislación aplicable</SectionTitle>
      <p data-id="element-145">
        Estos términos se rigen por la legislación española. Para cualquier
        controversia, las partes se someten a los juzgados y tribunales
        competentes.
      </p>

      <SectionTitle data-id="element-146">11. Contacto</SectionTitle>
      <p data-id="element-147">
        Para cualquier consulta relacionada con estos términos, puedes
        contactarnos a través de nuestro correo electrónico de soporte.
      </p>
    </>;
}